import ExpenseCalculator from "./ExpenseCalculator";
function App() {
  return (
      <ExpenseCalculator></ExpenseCalculator>
  );
}
export default App;
